import { render, staticRenderFns } from "./MailListModal.vue?vue&type=template&id=d83c782c&scoped=true&"
import script from "./MailListModal.vue?vue&type=script&lang=js&"
export * from "./MailListModal.vue?vue&type=script&lang=js&"
import style0 from "./MailListModal.vue?vue&type=style&index=0&id=d83c782c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d83c782c",
  null
  
)

export default component.exports